<template>
  <div class="keyword-assistant">
    <div class="form-wraper"
         v-if="noResult">
      <h2>市场洞察工具</h2>
      <form-combination :formData="formData"
                        ref="formData"></form-combination>
      <el-button type="primary"
                 @click="sendReport"
                 :loading="loading">发送报告</el-button>
    </div>
    <div v-else
         class="keyword-detail-inspectoscope">
      <h2>成功建立分析任务</h2>
      <h5 class="text">目前正在进行市场洞察分析，成功后会将结果发送至目标邮箱，请注意查收。</h5>
      <el-button type="primary"
                 @click="reAnalysis">继续分析</el-button>
    </div>
  </div>
</template>

<script>
import formCombination from "@/components/iglobalwin/formCombination/formCombination.vue";
import seoApi from '@/backend/services/seo/seoBoard.js'
import api from '@/backend/apiConfig/apiConfig.js'
import { mapActions, mapGetters } from 'vuex'
import { validRequired, validUrl } from "@/common/elementValid";
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js'
import vm from "@/common/confirm.js";

export default {
  name: 'keyword-assistant',
  components: {
    formCombination
  },
  data () {
    return {
      loading: false,
      noResult: true,
      formData: {},
      selectType: [
        {
          label: '智能词组分析',
          value: '0'
        },
        {
          label: '市场追踪报告',
          value: '1'
        }
      ],
    }
  },
  computed: {
    ...mapGetters(['keywordLanguages'])
  },
  watch: {
    'formData.type.value': {
      handler (val) {
        this.setFormData(val);
      },
    }
  },
  methods: {
    ...mapActions(['getLanguageList']),
    getLanguages () {
      this.getLanguageList().then(res => {
        this.formData.language.options = res
      }).catch(e => console.error(e))
    },
    reAnalysis () {
      this.noResult = true
      this.setFormData();
    },
    sendReport () {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          try {
            // this.loading = true
            this.noResult = false
            let res = await simpleFormPageCreate({
              api: api.seo.keywordReport,
              type: 'Post',
              data: this.formData,
              config: {
                timeout: 60000
              }
            }, res => {
              res.email = `${res.email}@skytech.cn`
              res.locationNames = this.getLocationName(res.locationIds)
              if (res.type == 0) res.phrase = this.getPhrase(res.phrase)
              delete res.net
              return res
            }).submit()
            if (res.status >= 200 && res.status < 400) {
              // this.loading = false
              // vm._success('发送成功')
              // this.$refs.formData.reset()
            }
          } catch (e) {
            // this.loading = false
            // vm._info('发送失败')
            console.error(e)
          }
        }
      })
    },
    getPhrase (phrase) {
      if (!phrase) throw new Error('phrase is not null')
      if (phrase.indexOf('，') >= 0) return phrase.replace(/，/g, ',')
      return phrase
    },
    getLocationName (locationIds) {
      if (locationIds.length == 0) return ''
      let names = []
      this.formData.locationIds.options.map(option => {
        locationIds.find(locationId => {
          if (locationId == option.criteriaId) names.push(option.nameChinese)
        })
      })
      return names.length > 0 ? names.join(',') : names.toString()
    },
    generateInput (val) {
      let { label, tips } = val == '0'
        ? { label: '词组', tips: '请添加词组，多个请用逗号隔开' }
        : { label: '网址', tips: '请添加要分析的网址（例：https://www.iglobalwin.com）' }
      return {
        'phrase': {
          label: label,
          formType: 'sky-input',
          value: '',
          placeholder: tips,
          rules: label == '网址' ? [validRequired('请添加网址'), validUrl(), 'blur'] : [validRequired('请添加词组'), 'blur']
        }
      }
    },
    async remoteMethod (queryValue) {
      try {
        if (queryValue != '') {
          let res = await seoApi.queryGeotargets({ condition: queryValue })
          if (res.status >= 200 && res.status < 400) {
            let locations = _.cloneDeep(this.formData.locationIds.options)
            if (Array.isArray(res.data)) {
              let isHas = true
              res.data.map(item => {
                isHas = locations.some(loc => loc.nameChinese == item.nameChinese)
              })
              if (!isHas) this.formData.locationIds.options = locations.concat(res.data)
            }
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    setFormData (val) {
      let formType = this.generateInput(val)
      const that = this
      this.formData = {
        type: {
          label: '分析类型',
          formType: 'sky-select',
          value: val,
          options: that.selectType,
          placeholder: '请选择类型',
          rules: [validRequired(), 'change']
        },
        ...formType,
        locationIds: {
          label: '位置',
          formType: 'sky-select',
          value: [],
          options: [],
          props: {
            label: 'nameChinese',
            value: 'criteriaId'
          },
          filterable: true,
          remote: true,
          multiple: true,
          'remote-method': that.remoteMethod,
          placeholder: '请输入你想要分析的国家',
          rules: [validRequired('请输入你想要分析的国家', "blur", "array")]
        },
        language: {
          label: '语言',
          formType: 'sky-select',
          value: '',
          filterable: true,
          options: that.keywordLanguages,
          props: {
            label: 'chineseName',
            value: 'criterionId'
          },
          placeholder: '请选择语言',
          rules: [validRequired('请选择语言'), 'change']
        },
        net: {
          label: '搜索网络',
          formType: 'sky-input',
          value: 'Google',
          disabled: true,
          placeholder: '请输入搜索网络',
          rules: [validRequired(), 'blur']
        },
        email: {
          label: '接收邮箱',
          formType: 'sky-input',
          vSlot: 'append',
          slotProp: '@skytech.cn',
          value: '',
          placeholder: '请输入接收邮箱',
          rules: [validRequired('请输入接收邮箱'), 'blur']
        }
      }
    }
  },
  mounted () {
    this.getLanguages()
    this.setFormData();
  },
}
</script>

<style lang="scss" scoped>
.keyword-assistant {
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding: 20px;
  text-align: center;
  .form-wraper {
    width: 50%;
    margin: auto;
    h2 {
      margin-bottom: 40px;
    }
  }
  .text {
    margin: 40px 0;
  }
}
</style>